import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import CONFIG from "@/assets/js/config.custom.js";

export default {
  name: 'scoreSettingDetail',
  components: {
    MainLayout,
    Loading,
  },

  data() {
    return {
      isLoading: true,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      scoreData: {}
    };
  },

  methods: {
    getScoreInfo() {
      this.isLoading = true;
      axios.get(`/score-setting/${this.$route.params.id}/info`)
      .then((res) => {
        if (res.data) {
          this.scoreData = res.data;
          this.isLoading = false;
        }
      })
      .catch(error => {
        this.isLoading = false;
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error("Error fetching score info:", error);
      })
    },

    showList() {
      this.$router.push({
        path: "/score-setting"
      })
    },
  },

  mounted() {
    this.isLoading = true;
    this.getScoreInfo();
  },
};
